import * as types from '../../actions/actionsTypes/notifsActionTypes';

export const initialStateNotifs = [];

export const notifsReducer = (state = initialStateNotifs, action) => {
    if (!action || !action.type) return state;

    switch (action.type) {
        case types.NOTIF_SEND:
            if (state.length === 0) {
                const notif = Object.assign({}, action.payload);
                if (!notif.id) {
                    notif.id = new Date().getTime();
                    notif.isOpen = true;
                    notif.setTimeout = false;
                }

                return [notif];
            } else {
                const checkState = state.filter(x => x.isOpen);
                if (!checkState.map(x => x.message).includes(action.payload.message)) {
                    const notif = Object.assign({}, action.payload);
                    if (!notif.id) {
                        notif.id = new Date().getTime();
                        notif.isOpen = true;
                        notif.setTimeout = false;
                    }

                   checkState.unshift(notif);
                }
                return [...checkState];
            }

        case types.NOTIF_DISMISS: {
            const newState = state.filter(notif => notif.id !== action.notifDismissId);
            const notifDismiss = state.find(notif => notif.id === action.notifDismissId);
            if (notifDismiss != null) {
                return [...newState, {...notifDismiss, isOpen: false}];
            } else {
                return newState
            }
        }

        case types.NOTIF_CLEAR : {
            return state.filter(x => !!x.isOpen);
        }

        case types.RESET_NOTIF:
            return [];

        default:
            return state;
    }
};
